import React, {useState, useEffect, useRef} from 'react';
import { 
    Flex, Text, Button, HStack, VStack, Checkbox, Image, Divider, Link, Select,
    FormControl, FormLabel, InputGroup, Input, InputLeftAddon, Icon,
    Center, CircularProgress, CircularProgressLabel, useToast, useDisclosure,
    Heading
} from '@chakra-ui/react';
import axios from 'axios';
import { useCookies } from "react-cookie";
import { Form, Field } from "react-final-form";
import { MdSave } from 'react-icons/md';
import { sleep } from "../../utils";

function Config({ }) {
    const [ cookies, setCookie, removeCookie ] = useCookies(["loginCookie"]);

    const toast = useToast();
    const mouted = useRef();

    const [isLoading, setIsLoading] = useState(false);
    const [configDetail, setConfigDetail] = useState(null);

    useEffect(() => {
        if(!mouted.current) {
            getConfigDetail();
            mouted.current = true;
        }
    }, []);

    const getConfigDetail = async() => {
        const res = await axios.get(`${process.env.REACT_APP_API_ENDPOINT_URL}/tradingview/auto_trade/configs`, 
            {
                auth: {
                    username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                    password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                }
            }
        );
        //console.log("--- getConfigDetail", res.data)
        setConfigDetail(res.data.data);
    }

    const validate = (values) => {
        const errors = {};

        if(!values.financial_leverage) {
            errors.financial_leverage = "Required";
        }
        if(!values.long_profit_percentage) {
            errors.long_profit_percentage = "Required";
        }
        if(!values.short_profit_percentage) {
            errors.short_profit_percentage = "Required";
        }
        if(!values.stop_loss_percentage) {
            errors.stop_loss_percentage = "Required";
        }
        return errors;
    }

    const onSubmit = async(values) => {
        setIsLoading(true);
        await sleep(500);

        const res = configDetail?.id ?
            await axios.put(`${process.env.REACT_APP_API_ENDPOINT_URL}/tradingview/auto_trade/configs/${configDetail?.id}`, 
                values, 
                {
                    auth: {
                        username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                        password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                    }
                }
            )
            :
            await axios.post(`${process.env.REACT_APP_API_ENDPOINT_URL}/tradingview/auto_trade/configs`, 
                values, 
                {
                    auth: {
                        username: process.env.REACT_APP_BASIC_AUTH_USERNAME,
                        password: process.env.REACT_APP_BASIC_AUTH_PASSWORD
                    }
                }
            )

        if(res.data?.error) {
            toast({
                description: res.data?.error,
                status: "error",
                duration: 3000,
                isClosable: true,
                position: "bottom-right"
            });
        } else {
            toast({
                description: "Updated successful!",
                status: "success",
                duration: 3000,
                isClosable: true,
                position: "bottom-right"
            });
        }

        setIsLoading(false);
    }

    return (
        <Flex flexDirection="column" align="flex-start" w="100%" h="fit-content">
            <Flex flexDirection={{ base: "column", md: "row", lg: "row" }} w="100%" p={{ base: 2, md: 4, lg: 4 }} color="#FFF"
                opacity={isLoading ? 0.3 : 1} pointerEvents={isLoading ? "none" : "visible"} justify="center"
            >
                <Form
                    onSubmit={onSubmit}
                    initialValues={{
                        ...(configDetail || {})
                    }}
                    validate={validate}
                    render={({ handleSubmit, form, submitting, pristine, valid, values }) => {
                        return (
                            <form onSubmit={handleSubmit}>
                                <Heading>SET CONFIG AUTO TRADE BOT</Heading>
                                <Field name="financial_leverage">
                                    {({ input, meta }) => (
                                        <FormControl isRequired>
                                            <FormLabel>Financial leverage</FormLabel>
                                            <Input {...input} type="number" />
                                        </FormControl>
                                    )}
                                </Field>

                                <Field name="long_profit_percentage">
                                    {({ input, meta }) => (
                                        <FormControl isRequired>
                                            <FormLabel>Long profit percentage (%)</FormLabel>
                                            <Input {...input} type="number" />
                                        </FormControl>
                                    )}
                                </Field>

                                <Field name="short_profit_percentage">
                                    {({ input, meta }) => (
                                        <FormControl isRequired>
                                            <FormLabel>Short profit percentage (%)</FormLabel>
                                            <Input {...input} type="number" />
                                        </FormControl>
                                    )}
                                </Field>

                                <Field name="stop_loss_percentage">
                                    {({ input, meta }) => (
                                        <FormControl isRequired>
                                            <FormLabel>Stop loss percentage (%)</FormLabel>
                                            <Input {...input} type="number" />
                                        </FormControl>
                                    )}
                                </Field>

                                <Button colorScheme='blue' mr={3} type='submit' isDisabled={!valid || pristine}
                                    isLoading={isLoading}
                                    loadingText="Đang lưu"
                                    mt={4}
                                >
                                    <Icon boxSize={6} as={MdSave} marginRight="8px"/> 
                                    <Text fontSize="14px">Save</Text>
                                </Button>
                            </form>
                        )
                    }}
                />
            </Flex>

            {
                isLoading &&
                <Center w="100%">
                    <CircularProgress position="fixed" top="20vh" isIndeterminate size="200px" zIndex={9999}>
                        <CircularProgressLabel fontSize="24px" fontWeight="700" color="#2196f3">Loading</CircularProgressLabel>
                    </CircularProgress>
                </Center>
            }
        </Flex>
    )
}

export default Config;